export default {
  AGENT_CATEGORY: 'Comercial:',

  // 404 page
  PAGE_404_TITLE: 'Error 404 página no encontrada',
  PAGE_404_DESCRIPTION: 'No hemos podido encontrar la página que buscas, lo sentimos',
  PAGE_404_BUTTON: 'Salir de la aplicación',

  // 401 page
  PAGE_401_TITLE: 'Error 401 no autorizado',
  PAGE_401_DESCRIPTION: 'No está autorizado para acceder a ésta página',
  PAGE_401_BUTTON: 'Salir de la aplicación',

  // ADMIN
  ADMIN_HOME_TITLE: 'Bienvenido a la administración de Minerva',
  ADMIN_HOME_TEXT:
    'Desde aquí, a través del menú del lateral, podrás crear y editar ofertas y subir nuevos modelos tarifarios.',
  ADMIN_TABLE_RESULTS_PER_PAGE: 'Resultados por página',
  ADMIN_TABLE_NO_RESULTS: 'No hay datos que mostrar',
  ADMIN_UPDATE: 'Actualizar',
  ADMIN_CANCEL: 'Cancelar',
  ADMIN_CONTINUE: 'Continuar',
  ADMIN_CONFIRM: 'Confirmar',
  ADMIN_TABLE_HEADER_ACTIONS: 'Acciones',
  ADMIN_ALERT_TEXT: 'Ha ocurrido un error realizando la operación',
  ADMIN_OFFERS_MODAL_EDIT_TITLE: '¿Estás seguro de que quieres editar la oferta?',
  ADMIN_OFFERS_CREATE_BUTTON: 'Crear oferta (ES)',
  ADMIN_OFFERS_CREATE_BUTTON_PT: 'Crear oferta (PT)',
  ADMIN_OFFERS_TABLE_HEADER_ID: 'ID de la oferta',
  ADMIN_OFFERS_TABLE_HEADER_TYPE: 'Tipo',
  ADMIN_OFFERS_TABLE_HEADER_STATUS: 'Estado de la oferta',
  ADMIN_OFFERS_TABLE_HEADER_VALIDATION_STATUS: 'Estado de validación',
  ADMIN_OFFERS_TABLE_HEADER_COMMERCIAL: 'Comercial',
  ADMIN_OFFERS_TABLE_HEADER_CREATION_DATE: 'Fecha de creación',
  ADMIN_RATE_MODELS_TABLE_HEADER_ID: 'ID del modelo',
  ADMIN_RATE_MODELS_TABLE_HEADER_DESCRIPTION: 'Descripción',
  ADMIN_RATE_MODELS_TABLE_HEADER_ORGANIZATION: 'Organización',
  ADMIN_RATE_MODELS_TABLE_HEADER_CURRENCY: 'Moneda',
  ADMIN_RATE_MODELS_TABLE_HEADER_IS_DEFAULT: 'Por defecto',
  ADMIN_RATE_MODELS_TABLE_HEADER_IS_ACTIVE: 'Activo',
  ADMIN_RATE_MODELS_TABLE_HEADER_START_DATE: 'Fecha inicio',
  ADMIN_RATE_MODELS_TABLE_HEADER_END_DATE: 'Fecha fin',
  ADMIN_RATE_MODELS_TABLE_HEADER_PAYMENT_DAY_LIMIT: 'Límite días pago',
  ADMIN_RATE_MODELS_TABLE_HEADER_PAYMENT_METHODS: 'Métodos de pago',
  ADMIN_RATE_MODELS_TABLE_HEADER_EXTRA_SERVICES: 'Servicios extra',
  ADMIN_RATE_MODELS_TABLE_HEADER_LEGAL_CITIES: 'Ciudades',
  ADMIN_RATE_MODELS_UPLOAD_BUTTON: 'Cargar nuevo modelo',
  ADMIN_RATE_MODELS_MODAL_TITLE: 'Nuevo modelo tarifario',
  ADMIN_TRANSLATIONS_ADD_BUTTON: 'Añadir traducción',
  ADMIN_TRANSLATIONS_MODAL_CREATE_TITLE: 'Añadir traducción',
  ADMIN_TRANSLATIONS_MODAL_EDIT_TITLE: 'Editar traducción',
  ADMIN_TRANSLATIONS_MODAL_DELETE_TITLE: '¿Estás seguro de que quieres eliminar esta traducción?',
  ADMIN_TRANSLATIONS_TABLE_HEADER_KEY: 'Clave',
  ADMIN_TRANSLATIONS_TABLE_HEADER_VALUE: 'Valor',
  ADMIN_TRANSLATIONS_FORM_KEY_FORMAT_ERROR:
    'La clave sólo puede contener letras mayúsculas, números y guiones bajos (_) y debe empezar por una letra',

  // MAIN HEADER
  MENU_SECTION_HOME: 'Home',
  MENU_SECTION_OFFERS: 'Ofertas',
  MENU_SECTION_RATE_MODELS: 'Modelos tarifarios',
  MENU_SECTION_TRANSLATIONS: 'Traducciones',

  // STEPPER
  STEPPER_BUTTON_BEFORE: 'Anterior',
  STEPPER_BUTTON_AFTER: 'Continuar',
  STEPPER_BUTTON_END: 'Finalizar',
  STEPPER_BUTTON_SIGN: 'Firma digital',
  STEPPER_BUTTON_MANUAL_SIGN: 'Firma manual',
  STEPPER_STEP1_LABEL: 'Productos y portes',
  ADDITIONAL_SERV_LABEL: 'Servicios adicionales',
  STEPPER_STEP3_LABEL: 'Forma de pago',
  STEPPER_STEP4_LABEL: 'Detalle de bultos',
  STEPPER_STEP5_LABEL: 'Dispersión de productos',
  STEPPER_STEP6_LABEL: 'Firma de Contrato',
  STEPPER_STEPINIT_TITLE: 'Selecciona un modelo tarifario',
  STEPPER_STEPINIT_FIELD: 'Modelo Tarifario',
  STEPPER_STEPINIT_LABEL: 'Modelo Tarifario',
  STEPPER_LEGAL_CITY_FIELD: 'Ciudad juridica',
  STEPPER_STEPINIT_ADDRESSES_LEAD: 'Puntos de Servicio',
  STEPPER_STEPINIT_MAIN_ADDRESS: 'Principal',
  STEPPER_STEPINIT_ADDRESS: 'Dirección',
  STEPPER_STEPINIT_SHIPPING_AMOUNT: 'Número de envíos',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_EXCESS_ERROR:
    'Revisa el número de envíos asignado a cada punto, actualmente te excedes en {diff} envíos. <br> El total no debe superar al número de envíos comprometidos por mes ( {total} envíos).',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_GAP_ERROR:
    'Revisa el número de envíos asignado a cada punto, actualmente te faltan {diff} envíos. <br> El total no debe superar al número de envíos comprometidos por mes ( {total} envíos).',
  STEPPER_STEPINIT_FAVORITE_ERROR: 'Debes elegir un Punto de Servicio principal',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_NULL: 'Este campo es obligatorio',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_NEGATIVE:
    'El valor debe ser mayor o igual a cero',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_FLOAT: 'El valor debe ser un número entero',
  STEPPER_STEPINIT_CLONE_OFFER_TITLE: 'Clonar oferta',
  STEPPER_STEPINIT_CLONE_OFFER_PLACEHOLDER: 'ID de la oferta de origen',
  STEPPER_STEPINIT_CLONE_OFFER_BUTTON: 'Clonar oferta',
  STEPPER_STEPINIT_CLONE_OFFER_ERROR_404: 'Oferta de destino no encontrada',
  STEPPER_STEPINIT_CLONE_OFFER_ERROR_406:
    'El modelo tarifario de la oferta de origen ya no se encuentra activo',
  STEPPER_STEPINIT_CLONE_OFFER_ERROR_409: 'La oferta de origen no existe',
  STEPPER_STEP1_H1: 'Selecciona los productos a ofertar',
  STEPPER_STEP1_H1_READONLY: 'Productos',
  STEPPER_STEP1_DESCRIPTION:
    'Selecciona los productos a incluir en la oferta. Los marcados como obligatorios deben ser recomendados al cliente.',
    STEPPER_STEP1_DESCRIPTION2:
    'El modelo de Venta Directa actual no tiene ningún producto marcado como obligatorio.',
  STEPPER_STEP1_H3: 'Productos obligatorios',
  TARIFF_STANDARD_24H: 'Ctt 24h - Ctt e24h',
  TARIFF_STANDARD_13H: 'Ctt 14:00h',
  TARIFF_STANDARD_10H: 'Ctt 10:00h',
  TARIFF_STANDARD_08H: 'Ctt 08:30h',
  TARIFF_STANDARD_48H: 'Ctt 48h - e48h',
  TARIFF_STANDARD_E24H: 'e24h (Para Amanhã; Devoluçao Fácil)',
  TARIFF_STANDARD_E48H: '48h (Em 2 Dias)',
  TARIFF_STANDARD_e24H: 'e24h (Para Amanhã; Devoluçao Fácil)',
  TARIFF_STANDARD_e48H: '48h (Em 2 Dias)',
  TARIFF_STANDARD_10H_PT: 'CTT 10h',
  TARIFF_STANDARD_13H_PT: 'CTT 14h',
  TARIFF_STANDARD_19H_19M: '24h / 24hM ( 19h / 19M )',
  TARIFF_STANDARD_24H_PT: 'CTT 24h',
  TARIFF_STANDARD_48H_PT: 'CTT 48h',
  TARIFF_STANDARD_E24H_PT: 'CTT e24h / Easy Return',
  TARIFF_STANDARD_E48H_PT: 'CTT e48h (Em 2 Dias)',
  TARIFF_STANDARD_PTE: 'Ilhas PT (Aéreo)',
  TARIFF_STANDARD_PTE_ACORES: 'Ilhas PT (Aéreo) - Açores',
  TARIFF_STANDARD_PTE_MADEIRA: 'Ilhas PT (Aéreo) - Madeira',
  TARIFF_STANDARD_PTM: 'Ilhas PT (Marítimo)',
  TARIFF_STANDARD_PTI: 'Interilhas PT',
  TARIFF_STANDARD_BALEXPRESS: 'CTT 24h (Baleares)',
  TARIFF_STANDARD_BALMARITIMO: 'CTT Marítimo (Baleares)',
  TARIFF_STANDARD_CANEXPRESS: 'CTT 24h (Canárias)',
  TARIFF_STANDARD_OTHERDESTINATIONS: 'Outros Destinos',
  OTHERDESTINATIONS: 'CTT Otros destinos',
  TARIFF_CANARY_13: 'Canarias 14:00h',
  TARIFF_CANARY_24: 'Canarias 24h',
  TARIFF_STANDARD_14H_PT: 'CTT 14h',
  TARIFF_STANDARD_PTIEXPRESS: 'CTT 24h (Ilhas PT)',
 TARIFF_STANDARD_PTIEXPRESS_RAA: 'CTT 24h (Ilhas PT) - Açores',
  TARIFF_STANDARD_PTIEXPRESS_LPMA: 'CTT 24h (Ilhas PT) - Madeira',
  TARIFF_STANDARD_PTIECONOMY: 'CTT Marítimo (Ilhas PT)',
  TARIFF_STANDARD_BALECONOMY: 'CTT Marítimo (Baleares)',
  TARIFF_STANDARD_CANECONOMY: 'CTT Marítimo (Canárias)',
  TARIFF_STANDARD_OTHERDESTINATIONS_PT: 'Outros Destinos',
  TARIFF_STANDARD_CCAR_PT: 'Carga',
  JSON_INTSTD: 'Internacional Economy',
  TARIFF_STANDARD_CIES: 'Internacional Economy',
  JSON_FRANCIA: 'Francia',
  JSON_ZONE1: 'Zona 1',
  ZONE_1: 'Zona 1',
  JSON_ZONE2: 'Zona 2',
  ZONE_2: 'Zona 2',
  JSON_ZONE3: 'Zona 3',
  ZONE_3: 'Zona 3',
  JSON_ZONE4: 'Zona 4',
  ZONE_4: 'Zona 4',
  JSON_ZONE5: 'Zona 5',
  ZONE_5: 'Zona 5',
  JSON_ZONE6: 'Zona 6',
  ZONE_6: 'Zona 6',
  JSON_ZONE7: 'Zona 7',
  ZONE_7: 'Zona 7',
  JSON_ZONE8: 'Zona 8',
  ZONE_8: 'Zona 8',
  JSON_ZONE9: 'Zona 9',
  ZONE_9: 'Zona 9',
  JSON_ZONEA: 'Zona A',
  JSON_ZONEB: 'Zona B',
  JSON_ZONEC: 'Zona C',
  JSON_ZONED: 'Zona D',
  JSON_ZONEE: 'Zona E',
  JSON_ZONEF: 'Zona F',
  JSON_ZONEG: 'Zona G',
  JSON_ZONEH: 'Zona H',
  JSON_ZONEI: 'Zona I',
  JSON_ZONES: 'Zona S',
  JSON_ZONET: 'Zona T',
  JSON_ZONEU: 'Zona U',
  JSON_ZONEV: 'Zona V',
  JSON_ZONEW: 'Zona W',
  JSON_ZONEX: 'Zona X',
  JSON_ZONEY: 'Zona Y',
  TARIFF_CANARY_ECOMMERCE: 'CTT Canarias Aéreo 24H',
  TARIFF_STANDARD_CCA24: 'CTT Canarias Aéreo 24H',
  TARIFF_STANDARD_CCA48: 'CTT Canarias Aéreo 48H',
  TARIFF_CANARY_MARITIME: 'CTT Canarias Marítimo',
  TARIFF_BALEAR_13: 'Baleares 14:00h',
  TARIFF_BALEAR_24: 'Baleares 24h - e24h',
  TARIFF_BALEAR_48: 'Baleares 48h - e48h',
  JSON_INTEXP: 'CTT Internacional Express',
  JSON_INT_ECOMMERCE: 'CTT Internacional Ecommerce',
  JSON_INT_ELIGHT: 'CTT Internacional Europa Light',
  TARIFF_STANDARD_CIEL: 'CTT Internacional Europa Light',
  JSON_BALMAY: 'Mallorca',
  JSON_BALMEN: 'Resto Islas',
  JSON_DE: 'Alemania',
  JSON_UK: 'Reino Unido',
  JSON_IT: 'Italia',
  JSON_BE: 'Bélgica',
  JSON_NL: 'Holanda',
  JSON_LU: 'Luxemburgo',
  JSON_PORTUGAL: 'Portugal',
  JSON_TNFLPA: 'Tnf & Lpa',
  JSON_IMENORES: 'I. Menores',
  JSON_INTERI: 'Interislas',
  JSON_MALLORCA: 'Mallorca',
  JSON_MADRID: 'Madrid',
  JSON_MADEIRA: 'Madeira',
  JSON_ACORES: 'Açores',
  JSON_MAIORCA: 'Maiorca',
  JSON_OUTRAS_ILHAS: 'Outras Ilhas',
  JSON_ILHA: 'Mesma Ilha',
  JSON_MARQUIPELAGO: 'Mesmo Arquipélago',
  JSON_EARQUIPELAGO: 'Entre Arquipélagos',
  JSON_INTERILHAS: 'Interilhas',
  JSON_ARQUIPELAGOS: 'Arquipélagos',
  STEPPER_STEP1_OPTIONAL: 'Opcionales',
  STEPPER_STEP1_OPTIONAL_SELECTALL: 'Seleccionar todos',
  TARIFF_STEP_CHANGE_OFFER_TYPE_CANCEL: 'Volver al paso anterior',
  TARIFF_STEP_CHANGE_OFFER_TYPE_CONTINUE: 'Continuar',
  TARIFF_STEP_CHANGE_OFFER_TYPE_TITLE:
    'Tu oferta es de tipo {offerType} y necesitas aportar más información de detalle',
  TARIFF_STEP_CHANGE_OFFER_TYPE_DESC:
    'Para finalizar la oferta de tipo {offerType} es necesario que nos aportes más información, a continuación te pediremos los datos requeridos.',
  TARIFF_CHANGE_OFFER_TYPE_TITLE: '¿Estas seguro de convertir la oferta en Tipo A?',
  TARIFF_CHANGE_OFFER_TYPE_DESC:
    'Al convertir la oferta en Tipo A todos los cambios que hayas realizado serán reiniciados.',
  TARIFF_CHANGE_OFFER_TYPE_BUTTON_CONTINUE: 'Convertir',
  TARIFF_CHANGE_OFFER_TYPE_BUTTON_CANCEL: 'Cancelar',

  // Sticky box
  STICKYBOX_TITLE: 'Datos cliente',
  STICKYBOX_SOCIAL_REASON: 'Razón social',
  STICKYBOX_CIF: 'CIF',
  STICKYBOX_MONTH: 'MES',
  STICKYBOX_COMPROMISED: 'Env. Comprometidos',
  STICKYBOX_INTERNATIONAL: 'Env. Internacionales',
  STICKYBOX_SERVICE_POINT: 'Prov. punto servicio',
  STICKYBOX_VALIDATION_TITLE: 'Datos oferta',
  STICKYBOX_VALID_STATUS: 'Validez',
  STICKYBOX_APPROB_STATUS: 'Estado',
  STICKYBOX_OFFER_TYPE: 'Tipo',
  STICKYBOX_OFFER_VERSION: 'Versión',
  STICKYBOX_VALID: 'Válida',
  STICKYBOX_INVALID: 'Inválida',
  STICKYBOX_APPROVED: 'Aprobada',
  STICKYBOX_UNAPPROVED: 'Pte. Aprobación',
  STICKYBOX_VALIDATING: 'En validación',
  STICKYBOX_REJECTED: 'Rechazada',
  STICKYBOX_RETURNED: 'Devuelta',
  STICKYBOX_TYPEA: 'Tipo A',
  STICKYBOX_TYPEB: 'Tipo B',
  STICKYBOX_TYPEC: 'Tipo C',
  STICKYBOX_TYPEF: 'Tipo F',
  STICKYBOX_BUTTON_SAVE: 'Guardar oferta',
  STICKYBOX_BUTTON_CONVERTA: 'Convertir Tipo A',
  STICKYBOX_BUTTON_CONVERTC: 'Convertir Tipo C',
  STICKYBOX_BUTTON_UPDATE_OFFER_STATUS: 'Actualizar estado',
  STICKYBOX_BUTTON_RESET: 'Cancelar oferta',
  STICKYBOX_COPY_OFFERID: 'Copiar ID',
  STICKYBOX_BUTTON_VALIDATIONS_TURN_ON: 'Activar validaciones',
  STICKYBOX_BUTTON_VALIDATIONS_TURN_OFF: 'Desactivar validaciones',
  STICKYBOX_BUTTON_MAX_DISCOUNTS: 'Descuentos MAX',
  STICKYBOX_BUTTON_RESET_DISCOUNTS: 'Reset descuentos',

  // Sticky Sign
  STICKYSIGN_CONTRACT: 'Datos del contrato',
  // Alerts
  ALERT_ZONE_ERROR:
    'Los descuentos del producto <b>{product}</b> no cumplen con las validaciones de precios entre zonas.',
  ALERT_PRODUCT_ERROR:
    'Los descuentos del producto <b>{product}</b> no cumplen con las validaciones de precios entre productos.',
  ALERT_ERROR_SERVICE: 'Servicio ',
  ALERT_TYPE_B_PRODUCT_PRICES:
    'Oferta de Tipo B debido a que los descuentos superan el máximo permitido por la Compañía.',
  ALERT_TYPE_B_PRODUCT_WEIGHTS:
    'Oferta de Tipo B debido a que se han modificado los pesos estándar.',
  ALERT_TYPE_B_ADDITIONAL_SERVICES:
    'Oferta de Tipo B debido a que el valor de los servicios adicionales requieren de aprobación.',
  ALERT_TYPE_B_PAYMENT_METHODS:
    'Oferta de Tipo B debido a que la forma de pago requiere de aprobación.',
  ALERT_TYPE_B_OPTY_SERVICE_POINTS:
    'Oferta de Tipo B porque contiene más de una dirección de recogida.',
  ALERT_TYPE_B_PRODUCTS:
    'Oferta de Tipo B debido a que se han seleccionado productos opcionales.',
  ALERT_BUTTON_SHOW: 'Ver más avisos',
  ALERT_BUTTON_HIDE: 'Ver menos avisos',
  ALERT_SHOW_DETAILS: 'Mostrar detalles',
  ALERT_HIDE_DETAILS: 'Ocultar detalles',
  ALERT_DETAILS_LABEL: 'Detalles:',

  //Shipping
  SHIPPING_TITLE: 'Configura los porcentajes de descuento y portes de los productos',
  SHIPPING_SUBTITLE:
    'Modifica la configuración de los porcentajes de descuento aplicado a los baremos de los productos seleccionados para ajustar la oferta según el cliente. <b>No recomendamos superar los porcentajes máximos marcados</b>',
  SHIPPING_ADDITIONAL_KG: 'Kg adicional',
  SHIPPING_DISCOUNTS_UNLOCK: 'Desbloquear descuentos',
  SHIPPING_DISCOUNTS_LOCK: 'Bloquear descuentos',
  SHIPPING_ADDED_ROW2_DISCOUNT: 'Descuento',
  SHIPPING_HEADERS_WEIGHT: 'Peso (kg)',
  JSON_PROVINCE: 'Provincial',
  JSON_REGION: 'Regional',
  JSON_PENINSULAR: 'Peninsular',
  JSON_PENINSULARPLUS: 'Peninsular+',
  JSON_CEUTA: 'Ceuta',
  JSON_MELILLA: 'Melilla',
  JSON_ANDORRA: 'Andorra',
  JSON_GIBRALTAR: 'Gibraltar',
  JSON_PTISLANDS: 'Islas Portugal',
  JSON_PTIAEREO: 'Islas Portugal Aéreo',
  JSON_PTIMARITIMO: 'Islas Portugal Marítimo',
  JSON_CANMAY: 'Lpa - Tnf',
  JSON_CANEXPRESS: 'CTT Canarias Documentación',
  JSON_BALEXPRESS: 'Baleares Express',
  JSON_BALECONOMY: 'Baleares Economy',
  PRICE_MODAL_TITLE: 'Modificar precio',
  PRICE_MODAL_CHANGE: 'Cambiar',
  PRICE_MODAL_CANCEL: 'Cancelar',
  SHIPPING_MODAL_TITLE: 'Modificar número de envíos',
  SHIPPING_MODAL_CHANGE: 'Cambiar',
  SHIPPING_MODAL_CANCEL: 'Cancelar',
  SHIPPING_MODAL_ACTIONS_ADD: 'Confirmar',
  SHIPPING_MODAL_ACTIONS_DEFAULT_WEIGHTS: 'Seleccionar pesos por defecto',
  SHIPPING_MODAL_ACTIONS_CANCEL: 'Cancelar',
  SHIPPING_WEIGHTS_MODAL_TITLE: 'Selecciona los pesos que quieres mostrar en el producto {product}',
  SHIPPING_INVALID_DISCOUNTS_TAG: 'Adaptar descuentos',
  SHIPPING_MAX_DISCOUNTS_TAG: 'Descuento máximo superado',
  SHIPPING_MODIFIED_WEIGHTS_TAG: 'Pesos modificados',
  SHIPPING_TOOLTIP_WEIGHT_ERROR: 'El precio no debe ser inferior a tramos de kg inferiores',
  SHIPPING_TOOLTIP_ZONE_ERROR:
    'El precio de {weight} kg del baremo {zone1} debe ser superior al precio de {weight} kg del baremo {zone2}',
  SHIPPING_TOOLTIP_ZONE_ERROR_ALLOW_EQUAL:
    'El precio de {weight} kg del baremo {zone1} debe ser superior o igual al precio de {weight} kg del baremo {zone2}',
  SHIPPING_TOOLTIP_PRODUCT_ERROR:
    'El precio de {weight} del baremo {zone} del producto {product1} debe ser un {percentage}% superior al precio de {weight} del baremo {zone} del producto {product2}.',
  SHIPPING_TOOLTIP_PRODUCT_ERROR_NO_PERCENTAGE:
    'El precio de {weight} del baremo {zone} del producto {product1} debe ser superior al precio de {weight} del baremo {zone} del producto {product2}.',

  // step 2
  ADDITIONAL_SERV_TITLE: 'Configura los precios de los servicios adicionales',
  ADDITIONAL_SERV_NONE_TITLE: 'Servicios adicionales',
  ADDITIONAL_SERV_DESCRIPTION:
    'Algunos servicios no permiten modificar su precio. Los precios pueden ser fijos o un porcentaje del total.',
  ADDITIONAL_SERV_NONE_DESCRIPTION:
    'Este modelo tarifario no tiene servicios adicionales negociables.',
  ADDITIONAL_SERV_EDITION_DESCRIPTION: 'Configura el precio del servicio',
  ADDITIONAL_SERV_FIELD_BASE_PRICE: 'Precio base',
  ADDITIONAL_SERV_FIELD_PRICE: 'Importe ',
  ADDITIONAL_SERV_FIELD_PERCENTAGE: 'Porcentaje ',
  ADDITIONAL_SERV_FIELD_SELECT: 'Código',
  ADDITIONAL_SERV_FIELD_SELECTOR: 'Selecciona un código',
  ADDITIONAL_SERV_FIELD_MIN: 'Mínimo',
  ADDITIONAL_SERV_FIELD_MAX: 'Máximo',
  ADDITIONAL_SERV_FIELD_MIN_QUANTITY: 'Cantidad mínima',
  ADDITIONAL_SERV_FIELD_MAX_QUANTITY: 'Cantidad Máxima',
  ADDITIONAL_SERV_FIELD_EXPIRE_MONTHS: 'Meses de Vigencia',
  ADDITIONAL_SERV_SUFFIX_EXPIRE_MONTHS: 'meses',
  ADDITIONAL_SERV_EXPANSION_BUTTON_CANCEL: 'Cancelar',
  ADDITIONAL_SERV_EXPANSION_BUTTON_SAVE: 'Guardar',
  ADDITIONAL_SERV_VIEW_MORE: 'Ver otros servicios adicionales',
  ADDITIONAL_SERV_MODAL_TITLE: 'Servicios Adicionales',
  ADDITIONAL_SERV_MODAL_ACTIONS_CLOSE: 'Cerrar',
  ADDITIONAL_SERV_RULE_MANDATORY: 'Valor obligatorio',
  ADDITIONAL_SERV_RULE_STD_MIN_VALUE: 'El precio base mínimo es {value}{suffix}',
  ADDITIONAL_SERV_RULE_STD_MAX_VALUE: 'El precio base máximo es {value}{suffix}',
  ADDITIONAL_SERV_RULE_MIN_VALUE: 'La cantidad mínima no puede ser superior a {value}€',
  ADDITIONAL_SERV_RULE_MAX_VALUE: 'La cantidad máxima no puede ser inferior a {value}€',

  // Additional Services
  TEST: 'Prueba tipo lista/con select',
  SATURDAY_DELIVERY: 'Entrega en sábado (sólo para servicio 10:00h, 14:00h)',
  FINAL_MANAGE:
    'Gestión Final (servicios que requieran de alguna gestión en la recogida o en la entrega)',
  ANT_BASE: 'Servicio Anticipo valor Base',
  ANT_COMMISSION: 'Servicio de Anticipo',
  REFUND: 'Servicio de Reembolso',
  REFUND_2024: 'Comisión Servicio de Reembolsos (los envíos con reembolso no entregados no están sujetos a dicha comisión)',
  CTT_CARD: 'Tarjeta CTT PLUS (1 año)',
  FUEL: 'Bonificación Tasa Combustible',
  GROUPED_RETURN: 'Devolución agrupada albarán físico del cliente',
  OUTSKIRTS_KM: 'Kilómetros emisión Servicio 10:00h',
  DEST_PRINTING: 'Impresión en Destino hasta 5 hojas',
  ADIT_PRINTING: 'Impresión Adicional en Destino',
  DNI_VALIDATION: 'Validación del DNI del destinatario',
  OTP_TEXT: 'Servicio de entrega con OTP (One Time Password): Garantiza a través de un código PIN la entrega al destinatario final.',
  GRANDES_SUPERFICIES: 'Entrega en Gran Superficie (Servicio Especial para entregas en Grandes Superficies y Centros Logísticos). Este servicio se facturará por entrega, día y por cada dirección diferente.',
  SCAN_DELIVERY_NOTE: 'Albarán Cliente Escaneado',
  DGR: 'DGR - MMPP (Hielo Seco Baleares/Canarias)',
  REEX_CAN_INTER: 'Reexpedición Canarias Inter Islas',
  REEX_CAN_KG: 'Reexpedición Canarias Inter Islas Kg. Ad.',
  REEX_CAN_INTER_48: 'Reexpedición Canarias Inter Islas 48M 1 kg',
  REEX_CAN_INTER_48_MIN_50: 'Reexpedición Canarias Inter Islas Kg. Ad. < 50 kg 48M',
  REEX_CAN_INTER_48_MAX_50: 'Reexpedición Canarias Inter Islas Kg. Ad. > 50 kg 48M',
  PORTER: 'Ayudante / Mozo (fracción mín. 1 hora)',
  EXC_WEIGHT_40: 'Suplemento exceso peso por bulto (desde 40 kg a 70 kg)',
  EXC_WEIGHT_70: 'Suplemento exceso peso por bulto (desde 70 kg a 300 kg)',
  EXP_MEASURES_240: 'Suplemento exceso suma de medidas desde 240 cm hasta 300 cm',
  EXP_MEASURES_150: 'Suplemento exceso medida máxima desde 150 cm a 200 cm.',
  EXP_MEASURES_200: 'Suplemento exceso medida máxima desde 200 hasta 240 cm.',
  INTERCITY_KG: 'Suplemento Intercity Kg Adicional',
  FOURTH_ATTEMPT: 'Cuarto intento de entrega y siguientes',
  ECOMMERCE_HIGH_VALUE: 'Suplemento Canarias Ecommerce Alto Valor',
  REC_FAILED: 'Recogida fallida',
  REC_FAILED_PT: 'Recogida fallida PT (Portugal)',
  WAIT_TIME: 'Tiempo de Espera (por minuto)',
  DIR_FURGO_500: 'Dirección furgoneta 500 kg',
  KM_FURGO_500: 'Kilómetro furgoneta 500 kg',
  DIR_FURGO_1500: 'Dirección furgoneta 1500 kg',
  KM_FURGO_1500: 'Kilómetro furgoneta 1500 kg',
  SM_FURGO_500: 'Servicio Mínimo furgoneta 500 kg',
  SM_FURGO_1500: 'Servicio Mínimo furgoneta 1500 kg',
  SEG_TX_VOL: 'Incremento de indemnización legal por pérdida o robo: Límite hasta 2.000€/envío (ley 15/09 CTTM. Art. 63). (Excluidas roturas, desperfectos, averías que se abonarán de acuerdo a lo recogido en CMR)',
  POD: 'Prueba de entrega',
  RWA: 'Suplemento RWA (en caso de dirección incorrecta)',
  REMOTE_AREAS_A: 'Áreas Remotas (Zonas A)',
  REMOTE_AREAS: 'Áreas Remotas (consultar en www.cttexpress.com)',
  REMOTE_AREAS_BC: 'Áreas Remotas (Zonas B-C)',
  REMOTE_AREAS_KG: 'Áreas Remotas kg',
  REMOTE_AREAS_KG_BC: 'Áreas Remotas kg (Zonas B-C)',
  SPC_HAND_EXC_DIM: 'SPECIAL HANDLING Exceed Dimensions',
  SUPL_EMBALAJE: 'Suplemento manipulación - Embalaje',
  SUPL_DIMENSION: 'Suplemento manipulación - Dimensión',
  SUPL_PESO: 'Suplemento manipulación - Peso (peso real superior a 31 kg)',
  DRY_ICE: 'Hielo Seco',
  DANGER_GOODS_ADG: 'Mercancías Peligrosas accesibles (ADG)',
  DANGER_GOODS_IDG: 'Mercancías Peligrosas accesibles (IDG)',
  PRIORITY: 'Envío Prioritario (sticker visible con prioridad)',
  SHIPMENT_9_MIN_70: 'Entrega antes de las 9:00 < 70 Kgs.',
  SHIPMENT_9_MAX_70: 'Entrega antes de las 9:00 > 70 Kgs.',
  SHIPMENT_10_MIN_70: 'Entrega antes de las 10:00 < 70 Kgs.',
  SHIPMENT_10_MAX_70: 'Entrega antes de las 10:00 > 70 Kgs.',
  SHIPMENT_12_MIN_70: 'Entrega antes de las 12:00 < 70 Kgs.',
  SHIPMENT_12_MAX_70: 'Entrega antes de las 12:00 > 70 Kgs.',
  EXPORT_OUT_UE: 'Tasa Tramitación exportación fuera de la UE (DUA)',
  BAT_LITIO: 'Baterías de litio',
  SUST_BIO: 'Sustancias biológicas (Categoría B)',
  SATURDAY_FR: 'Entrega en Sábado Francia',
  CORSICA: 'Servicio Córcega',
  DEV_SHIPMENTS: 'Devolución de envíos no entregados',
  ENTR_INDV: 'Entregas a domicilios particulares',
  SEG_PORTES: 'Seguro Valor Portes',
  SEG_DECLARADO: 'Incremento de indemnización legal por pérdida o robo: Límite hasta 2.000€/envío (ley 15/09 CTTM. Art. 63). (Excluidas roturas, desperfectos, averías que se abonarán de acuerdo a lo recogido en el art 57 Ley 15/09 CTTM)',
  DUA_CAN_A_ALTO: 'DUA CTT Canarias Aéreo Alto valor',
  DUA_CAN_A_BAJO: 'DUA CTT Canarias Aéreo Bajo valor',
  DUA_CAN_MAR: 'DUA CTT Canarias Marítimo',
  DUA_MEL_ALTO_EX_PEN: 'DUA Melilla Alta valor Export Península',
  DUA_MEL_ALTO_IM_PEN: 'DUA Melilla Alta valor Export Melilla, Import Península',
  DUA_MELILLA_BAJO: 'DUA Melilla bajo valor',
  DUA_CEU: 'DUA Ceuta',
  DUA_GIB: 'DUA Gibraltar',
  DUA_AND: 'DUA Andorra',
  RECOGIDA: 'RECOGIDA SUPLEMENTO EVITA FALLO SGC',
  INTERCITY: 'INTERCITY SUPLEMENTO EVITA FALLO SGC',
  REEXPEDICION: 'REEXPEDICION EVITA FALLO SGC',
  REC_DENTRO_UE: 'Recogidas dentro de la UE',
  REC_FUERA_UE: 'Recogidas Fuera de la UE',
  SMS: 'Notificación SMS cambio de estado del envío',
  SMS_PT:'SMS (Notificações)',
  GARANTIAS: 'GARANTIAS DE SERVICIO EVITA FALLO SCG',
  VOL_CONVERSION: 'Conversión Volumétrica',
  VOL_CONVERSION_167A: 'Conversión a 167a',
  VOL_CONVERSION_167B: 'Conversión a 167b',
  SMS_SCG: 'SMS (SCG)',
  INTERCITY_SUP: 'Suplemento Intercity hasta 10kg',
  INTERCITY_ADIC: 'Suplemento Intercity Kg Adicional',
  SUPL_EXC_BULTO_KILO_ADIC:
    'Suplemento exceso peso por bulto por kilo adicional (a partir de 300 kg)',
  SUPL_EXC_MEDIDAS_300: 'Suplemento exceso suma de medidas por cada 10 cm (a partir de 300 cm)',
  SUPL_EXC_MEDIDAS_240: 'Suplemento exceso medida máxima por cada 10 cm (a partir de 240 cm)',
  SUPL_IRREGULARES: 'Suplemento por bulto para envíos irregulares',
  SUPL_EXP_MULTIBULTO: 'Suplemento por expedición multibulto (a partir del sexto bulto)',
  GARANTIA_SGC: 'GARANTIAS DE SERVICIO (SCG)',
  ENVIO_IMP_ADUANA_CEUTA: 'ENVIO - IMPUESTOS ADUANAS IPSI CEUTA, NO SUJETO-LIVA ART. 78',
  ENVIO_IVA_IMP_MELILLA: 'ENVIO - IVA IMPORTACION ORIGEN MELILLA, NO SUJETO-LIVA ART. 78 (TR109)',
  ENVIO_IMP_EXP_ENT_ISLAS: 'ENVIO - IMPUESTOS EXPORTACIÓN ENTRADA ISLAS, NO SUJETO-LIVA ART. 78',
  ENVIO_IVA_IMP_ENT_PEN: 'ENVIO - IVA IMPORTACION ENTRADA PENINSULA, NO SUJETO-LIVA ART. 78',
  ENVIO_IMP_ADUANERO_CEUTA_MELILLA:
    'ENVIO - IMPUESTOS ADUANEROS CEUTA / MELILLA, NO SUJETO-LIVA ART. 78',
  ENVIO_TRANS_ESP_AND: 'ENVIO - TRANSITARIO ESPAÑOL/ANDORRANO',
  ENVIO_IVA_IMP_INT: 'ENVIO - IVA IMPORTACION INTERNACIONAL',
  ENTREGA_GRAN_SUPERFICIE: 'Entrega en Gran Superficie',
  ENTREGA_GRAN_SUPERFICIE__PDF_ONLY:
    '(Servicio Especial para entregas en Grandes Superficies y Centros Logísticos). Este servicio se facturará por entrega, día y por cada dirección diferente',
  EXCESO_DIMENSIONES: 'Exceso de dimensiones',
  NO_TRANSPORTABLE: 'No transportable',
  NO_APILABLE: 'No apilable',
  EMBALAJE: 'Embalaje (AHS)',
  PESO: 'Peso (AHS)',
  INACTIVE: 'INACTIVO',
  NOT_INCLUDED: 'No incluido',
  NOT_INCLUDED_PT: 'Não incluido',
  EDP: 'Uso de Puntos Ctt Express:\n- Disponibles más de 17.000 puntos de servicio en toda la península ibérica, Islas Baleares, Azores y Madeira.\n- Recuerda que para poder hacer uso de los Puntos Ctt Express los envíos deben cumplir las siguientes características:\n  - Envío de 1 solo bulto.\n  - Peso máximo igual a 20 Kg.\n  - Suma de medidas > 160 cm (60 x 40 x 60).\n  - Sin servicio de retorno.\n  - Sin servicio de reembolso.\n  - Sin portes debidos.\n  - Sin servicio de gestión en destino.\n  - Sin servicio de escaneo de albarán del cliente.\n  - Sin servicio de verificación de DNI de destinatario.\n\nServicio de entrega directa en punto. Los usuarios pueden retirar sus envíos en los puntos de servicio. Descuento aplicable a cada envío para entrega directa en punto (EDP).',
  ENTREGA_DIRECTA_PUNTO: 'Bonificación Entrega Directa en Punto',
  RECOGIDA_DIRECTA_PUNTO: 'Bonificación Recogida Directa en Punto',
  ENTREGA_PONTO_CTT: 'Desconto Ponto de Entrega Collectt',
  JANELA_RECOLHA_8_10: 'Janela de recolha das 8 às 10',
  JANELA_RECOLHA_10_13: 'Janela de recolha das 10 às 13',
  JANELA_RECOLHA_13_16: 'Janela de recolha das 13 às 16',
  JANELA_RECOLHA_16_19: 'Janela de recolha das 16 às 19',
  JANELA_RECOLHA_19_22: 'Janela de recolha das 19 às 22',
  ALTERACAO_MORADA_RECOLHA: 'Alteração de morada de recolha',
  ALTERACAO_DATA_RECOLHA: 'Alteração de data de recolha',
  ALTERACAO_JANELA_RECOLHA_8_10: 'Alteração de janela de recolha das 8 às 10',
  ALTERACAO_JANELA_RECOLHA_10_13: 'Alteração de janela de recolha das 10 às 13',
  ALTERACAO_JANELA_RECOLHA_13_16: 'Alteração de janela de recolha das 13 às 16',
  ALTERACAO_JANELA_RECOLHA_16_19: 'Alteração de janela de recolha das 16 às 19',
  ALTERACAO_JANELA_RECOLHA_19_22: 'Alteração de janela de recolha das 19 às 22',
  ALTERACAO_JANELA_ENTREGA_NOITE: 'Alteração Janela Entrega Noite',
  ALTERACAO_DATA_DE_ENTREGA: 'Alteração Data de Entrega',
  ALTERACAO_DADOS_DESTINATARIO: 'Alteração Dados de Destinatario',
  ALTERACAO_DADOS_REMETENTE: 'Alteração Dados de Remetente',
  ALTERACAO_PRAZO_LEVANTAMENTO: 'Alteração Prazo Levantamento',
  ALTERACAO_MORADA_MORADA_MESMA_REGIAO: 'Alteração Morada-Morada (mesma Região)',
  ALTERACAO_MORADA_PONTO_MESMA_REGIAO: 'Alteração Morada-Ponto (mesma Região)',
  ALTERACAO_PONTO_MORADA_MESMA_REGIAO: 'Alteração Ponto-Morada (mesma Região)',
  ALTERACAO_PONTO_PONTO_MESMA_REGIAO: 'Alteração Ponto-Ponto (mesma Região)',
  ALTERACAO_MORADA_MORADA_OUTRA_REGIAO: 'Alteração Morada-Morada (outra Região)',
  ALTERACAO_MORADA_PONTO_OUTRA_REGIAO: 'Alteração Morada-Ponto (outra Região)',
  ALTERACAO_PONTO_MORADA_OUTRA_REGIAO: 'Alteração Ponto-Morada (outra Região)',
  ALTERACAO_PONTO_PONTO_OUTRA_REGIAO: 'Alteração Ponto-Ponto (outra Região)',
  TAXA_COMBUSTIVEL: 'Desconto em P.P. na taxa de energia cep.',
  '1_TENTATIVA_AVISAR_A_LOJA_CTT': '1ª Tentativa Avisar a Loja CTT',
  '1_TENTATIVA_DEVOLVER': '1ª Tentativa Devolver',
  TAXA_CARGA_DISFORME: 'Taxa disforme carga (% do valor dos portes).',
  TAXA_RECOLHA_NAO_EFETUADA: 'Taxa Recolha não Efectuada',
  TAXA_DISFORME: 'Taxa Disforme',
  TAXA_DISFORME_DEVOLUCAO: 'Taxa de Disforme - Devolução',
  TAXA_DESPACHO_UNICO_ADUANEIRO: 'Taxa Despacho Único Aduaneiro (DUA)',
  TAXA_CARGA_VOLUME: 'Taxa de Volume não cintável',
  TAXA_CARGA_MD3: 'Taxa MD3',
  TAXA_CARGA_ENTREGA_GRANDES_SUPERFICIES: 'Taxa Grandes Superfícies',
  'TAXA_REMESSA_9+': 'Taxa Remessa 9+ (por Objeto Extra)',
  MANHA: 'Janela Entrega Manhã',
  TARDE: 'Janela Entrega Tarde',
  NOITE: 'Janela Entrega Noite',
  SABADO: 'Janela Entrega Sábado',
  DOMINGO: 'Janela Entrega Domingo',
  SEGURO_EXTRA_ATE_1000: 'Proteção Extra - Até 1.000€',
  SEGURO_EXTRA_ATE_2500: 'Proteção Extra - Até 2.500€',
  SEGURO_EXTRA_ATE_5000: 'Proteção Extra - Até 5.000€',
  SEGURO_EXTRA_ATE_7500: 'Proteção Extra - Até 7.500€',
  SEGURO_EXTRA_ATE_10000: 'Proteção Extra - Até 10.000€',
  SEGURO_EXTRA_ATE_12500: 'Proteção Extra - Até 12.500€',
  SABADOB2B: 'Entregas ao Sábado',
  FRAGIL: 'Frágil',
  BACK: 'Back',
  DDA: 'DDA',
  COBRANÇA: 'Cobrança',
  COBRANCA_CARGA: 'Cobrança (Carga)',
  DDA_CARGA: 'DDA (Carga)',
  '2_TENTATIVA_AVISAR_A_LOJA_CTT': '2 Tentativas + Avisar à Loja CTT',
  '2_TENTATIVA_DEVOLVER': '2 Tentativas + Devolver',
  TENTATIVA_DE_ENTREGA_ADICIONAL: 'Tentativa de entrega adicional',
  ENTREGA_CONJUNTA: 'Entrega conjunta',
  CONTACTO_TELEFONICO: 'Contacto telefónico',
  ALTERACAO_JANELA_ENTREGA_MANHA: 'Alteração de janela de entrega de manhã',
  ALTERACAO_JANELA_ENTREGA_TARDE: 'Alteração de janela de entrega à tarde',
  TXENRGDISC: 'Desconto em P.P. na Taxa de Energia',
  TXRECNEFECT: 'Taxa Recolha não Efectuada',
  TXDISFORME: 'Taxa de Disforme – Transporte',
  TXDISFORMEDEV: 'Taxa de Disforme – Devolução',
  TXDUA: 'Taxa Despacho Único Aduaneiro (DUA)',
  "TXREMESSA9+": 'Taxa Remessa 9+ (por Objeto Extra)',
  PONTOCTT: 'Entrega Ponto CTT (Desconto)',
  '1TENTCC': '1 Tentativa + Avisar à Loja CTT',
  '1TENTDEV': '1 Tentativa + Devolver',
  '2TENTCTT': '2 Tentativa + Avisar à Loja CTT',
  ADTENT: 'Tentativa de Entrega Adicional',
  CONJUNTA: 'Entrega Conjunta',
  CONTACTO: 'Contacto Telefónico',
  ALTMANHA: 'Alteração Janela Entrega Manhã',
  ALTTARDE: 'Alteração Janela Entrega Tarde',
  ALTNOITE: 'Alteração Janela Entrega Noite',
  ALTDATA: 'Alteração Data de Entrega',
  ALTDESTINO: 'Alteração Dados Destinatário',
  ALTORIGEM: 'Alteração Dados Remetente',
  ALTPRAZO: 'Alteração Prazo Levantamento',
  ALTM2M_MMR: 'Alteração Morada-Morada (mesma Região)',
  ALTM2P_MMR: 'Alteração Morada-Ponto (mesma Região)',
  ALTP2M_MMR: 'Alteração Ponto-Morada (mesma Região)',
  ALTP2P_MMR: 'Alteração Ponto-Ponto (mesma Região)',
  ALTM2M_OTR: 'Alteração Morada-Morada (outra Região)',
  ALTM2P_OTR: 'Alteração Morada-Ponto (outra Região)',
  ALTP2M_OTR: 'Alteração Ponto-Morada (outra Região)',
  ALTP2P_OTR: 'Alteração Ponto-Ponto (outra Região)',
  REC1922: 'Janela Recolha 19-22',
  ALT0810: 'Alteração Janela Recolha 08-10',
  ALT1013: 'Alteração Janela Recolha 10-13',
  ALT1316: 'Alteração Janela Recolha 13-16',
  ALT1619: 'Alteração Janela Recolha 16-19',
  ALT1922: 'Alteração Janela Recolha 19-22',
  ALTMOR_MR: 'Alteração Morada Mesma Região',
  ALTMOR_OR: 'Alteração Morada Outra Região',

  STEPPER_DISTRIBUTION_B2B: 'Distribución B2B (%)',
  STEPPER_DISTRIBUTION_B2C: 'Distribución B2C (%)',
  STEPPER_DISTRIBUTION_ERROR: 'La suma debe ser exactamente 100%',

  // Step 3
  STEPPER_STEP3_TITLE: 'Forma de pago seleccionada',
  STEPPER_STEP3_APPROVED_TITLE: 'Formas de pago aprobadas',
  STEPPER_STEP3_WITHOUT_PAYMENT_DAY: 'Sin día de pago',
  STEPPER_STEP3_UNAPPROVED_TITLE: 'Formas de pago que necesitan aprobación',
  STEPPER_STEP3_VIEW_MORE: 'Ver más formas de pago',
  STEPPER_STEP3_VIEW_LESS: 'Ver menos formas de pago',
  PAYMENT_METHOD_RECEIPT: 'Adeudo directo inmediato',
  PAYMENT_METHOD_RECEIPT30: 'Adeudo directo a 30 días',
  PAYMENT_METHOD_RECEIPT60: 'Adeudo directo a 60 días',
  STEPPER_STEP3_PAYMENT_DAY_TITLE: 'Día de pago',
  STEPPER_STEP3_PAYMENT_DAY_LABEL: 'Dia de pago seleccionado',
  PAYMENT_METHOD_TRANS30: 'Transferencia a 30 días',
  PAYMENT_METHOD_TRANS60: 'Transferencia a 60 días',
  PAYMENT_METHOD_CHECK30: 'Cheque a 30 días',
  PAYMENT_METHOD_CHECK60: 'Cheque a 60 días',
  PAYMENT_METHOD_PAGARE30: 'Pagaré 30 días',
  PAYMENT_METHOD_PAGARE60: 'Pagaré 60 días',
  PAYMENT_METHOD_CONFIRM30: 'Corfirming a 30 días',
  PAYMENT_METHOD_CONFIRM60: 'Corfirming a 60 días',
  PAYMENT_METHOD_TRANS: 'Transferencia inmediata',
  PAYMENT_METHOD_DIRECT: 'Direct Lending',
  STEPPER_STEP3_BANK_GUARANTEE_TITLE: 'Datos del aval',
  GUARANTEE_AMOUNT: 'Importe del aval',
  GUARANTEE_TYPE_LABEL: 'Tipología del aval',
  GUARANTEE_TYPE_CASH: 'Deposito en metálico',
  GUARANTEE_TYPE_BANK: 'Aval bancario',
  GUARANTEE_DURATION_LABEL: 'Duración del aval',
  GUARANTEE_DURATION_UNDEFINED: 'Indefinido',
  GUARANTEE_DURATION_18_MONTHS: '18 meses',
  GUARANTEE_DURATION_30_MONTHS: '30 meses',
  GUARANTEE_DURATION_42_MONTHS: '42 meses',
  STEPPER_STEP3_DAYS_RULE_MANDATORY: 'Debes indícar el número de días',
  STEPPER_STEP3_DAYS_RULE_MIN: 'El día de pago debe ser superior a 0',
  STEPPER_STEP3_DAYS_RULE_MAX: 'El día de pago no puede ser superior a 30',
  STEPPER_STEP3_BANK_RULE_MANDATORY: 'Debes indícar un importe para el aval',
  PAYMENT_METHOD_DEBITO_DIRETO: 'Débito Direto',
  PAYMENT_METHOD_TRANSFERENCIA_BANCARIA_30: 'Transferência Bancária 30 Dias',
  PAYMENT_METHOD_TRANSFERENCIA_BANCARIA_60: 'Transferência Bancária 60 Dias',
  PAYMENT_METHOD_REFERENCIA_MULTIBANCO_30: 'Referência Multibanco 30 Dias',
  PAYMENT_METHOD_REFERENCIA_MULTIBANCO_60: 'Referência Multibanco 60 Dias',
  PAYMENT_METHOD_PAYSHOP_30: 'Payshop 30 Dias',
  PAYMENT_METHOD_PAYSHOP_60: 'Payshop 60 Dias',
  METHOD_DEBITO_DIRETO: 'Débito Direto',
  METHOD_TRANSFERENCIA_BANCARIA_30: 'Transferência Bancária 30 Dias',
  METHOD_TRANSFERENCIA_BANCARIA_60: 'Transferência Bancária 60 Dias',
  METHOD_REFERENCIA_MULTIBANCO_30: 'Referência Multibanco 30 Dias',
  METHOD_REFERENCIA_MULTIBANCO_60: 'Referência Multibanco 60 Dias',
  METHOD_PAYSHOP_30: 'Payshop 30 Dias',
  METHOD_PAYSHOP_60: 'Payshop 60 Dias',

  //Unlock discounts
  UNLOCK_DISCOUNTS_MODAL_TITLE:
    '¿Quieres desbloquear los descuentos y superar el descuento máximo recomendado?',
  UNLOCK_DISCOUNTS_MODAL_DESCRIPTION1:
    'Desbloqueando los descuentos podras superar límite máximo de descuento establecido.',
  UNLOCK_DISCOUNTS_MODAL_DESCRIPTION2:
    'La oferta pasará a estado "No aprobada" y deberá ser revisada por un auditor',
  UNLOCK_DISCOUNTS_MODAL_CANCEL: 'Cancelar',

  // Confirmación finalización de oferta
  FINALIZE_OFFER_MODAL_TITLE: '¿Estás seguro de finalizar la oferta?',
  FINALIZE_OFFER_MODAL_DESCRIPTION: 'Por favor antes de finalizar, verifica que los descuentos de los servicios adicionales ofertados no han variado.',
  FINALIZE_OFFER_MODAL_CANCEL: 'Cancelar',
  FINALIZE_OFFER_MODAL_CONTINUE: 'Continuar',
  LOCK_DISCOUNTS_MODAL_TITLE:
    '¿Quieres bloquear los descuentos y recuperar el descuento máximo recomendado?',
  LOCK_DISCOUNTS_MODAL_DESCRIPTION1:
    'Bloqueando los descuentos recuperarás el límite máximo de descuento establecido.',
  LOCK_DISCOUNTS_MODAL_DESCRIPTION2:
    'Perderás las modificaciones que hayan superado el descuento máximo permitido.',
  LOCK_DISCOUNTS_MODAL_CANCEL: 'Cancelar',

  // Step 4
  STEPPER_STEP4_TITLE: 'Introduce la información de detalle de los bultos',
  STEPPER_STEP4_DESC1: 'Para las ofertas de tipo {offerType} ',
  STEPPER_STEP4_DESC2: 'es necesario incorporar información adicional sobre los bultos',
  STEPPER_STEP4_SUBTITLE: 'Información de los bultos',
  STEPPER_STEP4_TEXTFIELD1: 'N° de bultos por expedición',
  STEPPER_STEP4_TEXTFIELD2: 'Tipo de mercancía',
  STEPPER_STEP4_SUBTITLE2: 'Detalles',
  STEPPER_STEP4_SUBTITLE3: 'Observaciones',
  STEPPER_STEP4_TEXTFIELD3: 'N° de envíos con reembolso (mes)',
  STEPPER_STEP4_TEXTFIELD4: 'Valor medio del reembolso (€)',
  STEPPER_STEP4_SUBTITLE4: 'Días de recogida semanales',
  STEPPER_STEP4_CHIP_MONDAY: 'Lunes',
  STEPPER_STEP4_CHIP_TUESDAY: 'Martes',
  STEPPER_STEP4_CHIP_WEDNESDAY: 'Miércoles',
  STEPPER_STEP4_CHIP_THURSDAY: 'jueves',
  STEPPER_STEP4_CHIP_FRIDAY: 'Viernes',
  STEPPER_STEP4_CHIP_SATURDAY: 'Sábado',
  STEPPER_STEP4_CHIP_SUNDAY: 'Domingo',
  STEPPER_STEP4_CHIP_MONDAY_TO_FRIDAY: 'De lunes a viernes',
  STEPPER_STEP4_HEADER_TYPE: 'Tipo de bulto',
  STEPPER_STEP4_HEADER_WEIGHT: 'Peso (kg)',
  STEPPER_STEP4_HEADER_LONG: 'Largo (cm)',
  STEPPER_STEP4_HEADER_WIDTH: 'Ancho (cm)',
  STEPPER_STEP4_HEADER_HEIGHT: 'Alto (cm)',
  STEPPER_STEP4_HEADER_PERCENTAGE: '% del total de bultos',
  STEPPER_STEP4_TABLE_DIALOG_TITLE: 'Datos del bulto',
  STEPPER_STEP4_TABLE_DIALOG_BUTTON_CLOSE: 'Cancelar',
  STEPPER_STEP4_TABLE_DIALOG_BUTTON_SAVE: 'Guardar',
  STEPPER_STEP4_TABLE_TOTAL: 'Total',
  STEPPER_STEP4_ERROR_MESSAGE: 'Debes rellenar este campo',
  STEPPER_STEP4_DAYS_OF_WEEK_REQUIRED: 'Debes seleccionar al menos un día de la semana',
  STEPPER_STEP4_NUMBER_ERROR_MESSAGE: 'Este campo debe contener un número mayor que 0',
  STEPPER_STEP4_NUMBER_NUMBEROFREFUNDS_0:
    'Este campo debe ser 0, al ser el valor medio del reembolso 0',
  STEPPER_STEP4_REFUNDS_VALUE_0:
    'Este campo debe ser 0, al ser el número de envíos con reembolso 0',
  STEPPER_STEP4_COMMITED_DELIVERIES_ERROR:
    'Este campo no debe superar el número de envíos comprometidos',
  STEPPER_STEP4_EXCEEDED_ERROR_MESSAGE: 'El porcentaje total de bultos debe sumar el 100%',
  STEPPER_STEP4_OBSERVATION_ERROR_MESSAGE: 'Las observaciones deben tener menos de 350 caracteres',
  STEPPER_STEP4_OBSERVATION_LABEL: 'Comentario observación (máx 350 caracteres)',
  STEPPER_STEP4_MODIFY_ITEM_MODAL_SAVE: 'Guardar',
  STEPPER_STEP4_MODIFY_ITEM_MODAL_CANCEL: 'Cancelar',
  STEPPER_STEP4_DELETE_TABLE_ITEM: '¿Seguro que quieres eliminar este bulto?',
  STEPPER_STEP4_DELETE_MODAL_TITLE: 'Eliminar bulto',
  STEPPER_STEP4_DELETE_BUTTON: 'Eliminar bulto',
  CLOTHING: 'Textil',
  COSMETICS: 'Cosmética',
  STATIONERY: 'Papelería',
  PERFUMERY: 'Perfumería',
  OPTICS: 'Óptica',
  REPLACEMENTS: 'Recambios',
  ANIMAL_FOOD: 'Alimentación animales',
  JEWELLERY: 'Joyería',
  HERBALIST: 'Herbolario',
  BOOKS: 'Libros',
  FURNITURE: 'Muebles',
  DOCUMENTS: 'Documentación',
  TECHNOLOGY: 'Tecnología',
  SHOES: 'Zapatos',
  WINES_AND_DRINKS: 'Vino y bebidas',
  FRUITS: 'Fruta',
  APPLIANCES: 'Electrodomésticos',
  WHEELS: 'Ruedas',
  CAR_GLASS: 'Lunas',
  HARDWARE_STORE: 'Ferretería (Mar. Herramienta)',
  OTHERS: 'Otros (explicar observaciones)',

  // Step 5
  STEPPER_STEP5_TITLE: 'Configura la dispersión de los productos de la oferta',
  STEPPER_STEP5_EDITION_DESCRIPTION: 'Configura la dispersión del producto y de las zonas',
  STEPPER_STEP5_TOTAL_MESSAGE: 'Total: {sum}',
  STEPPER_STEP5_FIELD_PRODUCT_DISPERSION: 'Dispersión del producto',
  STEPPER_STEP5_FIELD_ZONES: 'Para cada zona',
  STEPPER_STEP5_FIELD_ZONES_DESCRIPTION: '@.upper:STEPPER_STEP5_FIELD_ZONES',
  STEPPER_STEP5_FIELD_ZONES_CHIP_ERROR: 'La suma de las zonas no puede ser {sum}',
  STEPPER_STEP5_ALERT_ERROR_BASIC:
    'La suma de la dispersión de los productos debe ser igual al 100 %',
  STEPPER_STEP5_ALERT_ERROR:
    'La suma de la dispersión de los productos supera un {difference} % el máximo. No puede superar el 100 %',
  STEPPER_STEP5_ALERT_ERROR_MINUS:
    'La suma de la dispersión de los productos es un {difference} % inferior al límite. No puede ser inferior al 100 %',
  STEPPER_STEP5_DESCRIPTION:
    'Debes de detallar la dispersión (%) de cada producto y de cada zona dentro del producto.',

  STEPPER_SAVE_SUCCESS_ALERT_MESSAGE: 'La oferta ha sido guardada correctamente.',
  STEPPER_SAVE_ERROR_ALERT_MESSAGE: 'Ha ocurrido un error y no se ha podido guardar la oferta.',
  STEPPER_SAVE_CRM_ERROR_ALERT_MESSAGE:
    'Ha ocurrido un error de comunicación con el CRM y no se ha podido guardar la oferta.',

  STEPPER_RESET_DIALOG_TITLE: '¿Estás seguro?',
  STEPPER_RESET_DIALOG_DESC:
    'Al cancelar la oferta, se perderán todos los cambios y volverá al paso inicial. Esta acción no puede deshacerse.',
  STEPPER_RESET_DIALOG_BUTTON_CANCEL: 'No',
  STEPPER_RESET_DIALOG_BUTTON_CONFIRM: 'Sí',
  STEPPER_RESET_SUCCESS_ALERT_MESSAGE: 'La oferta ha sido cancelada.',
  STEPPER_RESET_ERROR_ALERT_MESSAGE: 'Ha ocurrido un error cancelando la oferta.',

  STEPPER_MANUAL_SIGN_DIALOG_TITLE: '¿Estás seguro?',
  STEPPER_MANUAL_SIGN_DIALOG_TEXT:
    'El contrato se marcará como firmado por el cliente y por lo tanto se dará de alta en la Compañía. Este paso no se puede deshacer.',
  STEPPER_MANUAL_SIGN_DIALOG_BUTTON_CONFIRM: 'Firmar',
  STEPPER_MANUAL_SIGN_DIALOG_BUTTON_CANCEL: 'Cancelar',
  STEPPER_MANUAL_SIGN_SUCCESS_ALERT_MESSAGE: 'La oferta ha sido firmada manualmente',
  STEPPER_MANUAL_SIGN_ERROR_ALERT_MESSAGE:
    'Ha ocurrido un error y no se ha podido firmar manualmente la oferta',

  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_TITLE: '¿Estás seguro?',
  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_TEXT:
    'La oferta está aprobada, si la modificas volverá a estar pendiente de aprobación.',
  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_BUTTON_CONFIRM: 'Confirmar',
  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_BUTTON_CANCEL: 'Cancelar',

  STEPPER_PHANTOM_OFFER_TITLE: 'Oferta de tipo F',
  STEPPER_PHANTOM_OFFER_TEXT_SIGN:
    'La oferta de tipo F ha finalizado. En caso de firmar el contrato con el cliente pulsa Firma Manual.',
  STEPPER_PHANTOM_OFFER_TEXT_SIGNED: 'Oferta firmada correctamente.',

  OFFER_REQUIRED_CLIENT_DATA_ERROR:
    'Faltan datos requeridos del cliente como: razón social, CIF, dirección o ciudad',
  OFFER_REQUIRED_MAIN_CONTACT_NIF_ERROR:
    'Es necesario incluir el NIF del contacto principal en la oferta',
  OFFER_REQUIRED_BANK_DATA_DEBIT_ERROR: 'Es necesario añadir los datos bancarios de la cuenta',
  OFFER_REQUIRED_BANK_DATA_REFUND_ERROR:
    'Es necesario añadir los datos bancarios para la gestión de reembolsos',

  //Contract
  PAGE2_COMMERCIAL: 'Su gestor comercial:',
  PAGE2_P1: 'Estimado/a cliente',
  PAGE2_P2:
    'Deseo agradecerte la confianza que has depositado en CTT Express como mejor opción para tus envíos de paquetería urgente.',
  PAGE2_P3:
    'A través de esta oferta de servicios de paquetería, queremos demostrarte que tenemos la mejor gama de servicios de paquetería urgente para el mercado Ibérico, incluyendo España y Portugal.',
  PAGE2_P4:
    'Esperando convertirnos muy pronto en un aliado para tu negocio, recibe un cordial saludo.',
  PAGE2_P5: 'Atentamente',
  PAGE2_COMMERCIAL_PT: 'Gestor comercial:',
  PAGE2_P1_PT: 'Estimado/a cliente',
  PAGE2_P2_PT: 
    'Gostaria de agradecer a confiança que depositou nos CTT, escolhendo-nos como a melhor opção para os seus envios de encomendas expresso.',
  PAGE2_P3_PT: 
    'Com esta oferta de serviços, pretendemos mostrar-lhe que dispomos da melhor oferta de soluções de encomendas expresso no mercado ibérico, incluindo tanto Portugal como Espanha.',
  PAGE2_P4_PT: 
    'Esperamos em breve ser o parceiro estratégico para seu negócio.',
  PAGE2_P5_PT: 'Atentamente,',
  PAGE2_DIRECTOR_NAME: 'Jorge Bousquet Alfonso',
  PAGE2_DIRECTOR_NAME_PT: 'Francisco Simões Travassos',
  PAGE2_DIRECTOR_JOB: 'Director Comercial de CTT EXPRESS',
  PAGE2_DIRECTOR_JOB_PT: 'Diretor de Produto CTT EXPRESS',

  PAGE_SIGNATURE_TITLE: 'Acuerdo Mercantil de Prestación de Servicios de Transporte (APS)',
  PAGE_SIGNATURE_TITLE_PT: 'Acordo de Prestação de Serviços de Transporte (APS)',
  SIGNATURE_SENT_DATE: 'Fecha de Envio',
  SIGNATURE_STATUS: 'Estado de la firma',
  SIGNATURE_DOCUMENT_ID: 'ID Documento',
  SIGNATURE_SIGN_ID: 'ID Firma',
  SIGNATURE_STATE_BTN: 'Actualizar Estado',
  SIGNATURE_SENT: 'Su contrato se ha enviado a firma correctamente',
  SIGNATURE_ERROR: 'Ha habido un error al enviar su contrato',
  SIGNATURE_CANCEL_ERROR:
    'Error al cancelar el proceso de firma. Por favor, inténtelo de nuevo más tarde',
  SIGNATURE_CANCEL_NOT_ALLOWED: 'El estado de la oferta no permite cancelar el proceso de firma',
  SIGNATURE_UPDATE_ERROR:
    'Error actualizando el estado de la firma. Por favor, inténtelo de nuevo más tarde',
  SIGN_CANCEL_BUTTON: 'Cancelar firma',
  CONTRACT_MODEL_NOT_VALID: 'El contrato asociado al modelo tarifario seleccionado no es válido',
  IN_QUEUE: 'En cola',
  EMAIL_PROCESSED: 'Email procesado',
  EMAIL_DELIVERED: 'Email enviado',
  EMAIL_OPENED: 'Email abierto',
  EMAIL_BOUNCED: 'Email rechazado',
  EMAIL_DEFERRED: 'Email rechazado. Reintentando',
  REMINDER_EMAIL_PROCESSED: 'Email de recordatorio procesado',
  REMINDER_EMAIL_DELIVERED: 'Email de recordatorio enviado',
  REMINDER_EMAIL_OPENED: 'Email de recordatorio abierto',
  DOCUMENT_OPENED: 'Documento abierto',
  DOCUMENT_SIGNED: 'Documento firmado',
  DOCUMENT_COMPLETED: 'Contrato firmado',
  DOCUMENT_DECLINED: 'Documento declinado',
  DOCUMENT_EXPIRED: 'Documento expirado',
  DOCUMENT_CANCELED: 'Documento cancelado',
  DECLINED: 'Proceso declinado',
  CANCELED: 'Proceso cancelado',
  AUDIT_TRAIL_COMPLETED: 'Contrato firmado',
  EXPIRED: 'Proceso expirado',
  ERROR: 'Error',
  MANUALLY_SIGNED: 'Firma manual',

  //SHIPPING PRODUCTS
  PRODUCT_24H: 'CTT 24h - CTT e24h',
  PRODUCT_13h: 'CTT 14h',
  PRODUCT_10h: 'CTT 10h',
  PRODUCT_08h: 'CTT 08:30h',
  PRODUCT_48h: 'CTT 48h - CTT e48h',
  PRODUCT_OTHERDESTINATIONS: 'CTT Otros destinos',
  PRODUCT_CAN13H: 'Canarias 14:00h',
  PRODUCT_CAN24H: 'Canarias 24h',
  PRODUCT_CANECOMMERCE: 'CTT Canarias Aéreo 24h',
  PRODUCT_CANMARITIMO: 'CTT Canarias Marítimo',
  PRODUCT_BAL13H: 'Baleares 14:00h',
  PRODUCT_BAL24H: 'Baleares 24h - e24h',
  PRODUCT_BAL48H: 'Baleares 48h - e48h',
  PRODUCT_INTEXP: 'CTT Internacional Express',
  PRODUCT_INTSTD: 'CTT Internacional Economy',
  PRODUCT_ECOMM: 'CTT Internacional Ecommerce',
  PRODUCT_INTREG: 'Internacional Regional',
  PRODUCT_INTPRIOR: 'Internacional Priority',
  PRODUCT_ELIGHT: 'CTT Internacional Europa Light',
  PRODUCT_CIEL: 'CTT Internacional Europa Light',
  PRODUCT_CANEXPRESS: 'CTT Canarias Documentación',
  PRODUCT_BALEXPRESS: 'CTT Baleares Express',
  PRODUCT_BALECONOMY: 'CTT Baleares Economy',
  PRODUCT_C14E: 'CTT Premium Empresas 14h',
  PRODUCT_CCA24: 'CTT Canarias Aéreo 24h',
  PRODUCT_CCA48: 'CTT Canarias Aéreo 48h',
  PRODUCT_EUROPE: 'Europa',
  PRODUCT_WORLD: 'Resto del mundo',
  PRODUCT_e24h: 'Para Amanhã',
  PRODUCT_e48h: 'Em Dois Dias',
  PRODUCT_19H_19M: '19H',
  PRODUCT_TARIFF_STANDARD_E24H: 'e24h (Para Amanhã; Devoluçao Fácil)',
  PRODUCT_TARIFF_STANDARD_E48H: '48h (Em 2 Dias)',
  PRODUCT_TARIFF_STANDARD_10H: 'CTT 10h',
  PRODUCT_TARIFF_STANDARD_13H: 'CTT 14h',
  PRODUCT_TARIFF_STANDARD_19H_19M: '24h / 24hM ( 19h / 19M )',
  PRODUCT_TARIFF_STANDARD_48H: 'CTT 48h - CTT e48h',
  PRODUCT_TARIFF_STANDARD_PTE: 'Ilhas PT (Aéreo)',
  PRODUCT_TARIFF_STANDARD_PTE_ACORES: 'Ilhas PT (Aéreo) - Açores',
  PRODUCT_TARIFF_STANDARD_PTE_MADEIRA: 'Ilhas PT (Aéreo) - Madeira',
  PRODUCT_TARIFF_STANDARD_PTM: 'Ilhas PT (Marítimo)',
  PRODUCT_TARIFF_STANDARD_PTI: 'Interilhas PT',
  PRODUCT_TARIFF_STANDARD_BALEXPRESS: 'CTT 24h (Baleares)',
  PRODUCT_TARIFF_STANDARD_BALMARITIMO: 'CTT Marítimo (Baleares)',
  PRODUCT_TARIFF_STANDARD_CANEXPRESS: 'CTT 24h (Canárias)',
  PRODUCT_TARIFF_STANDARD_OTHERDESTINATIONS: 'Outros Destinos',
   PRODUCT_TARIFF_STANDARD_24H: 'CTT 24h - CTT e24h',
  PRODUCT_TARIFF_STANDARD_10H_PT: 'CTT 10h',
  PRODUCT_TARIFF_STANDARD_13H_PT: 'CTT 13h',
  PRODUCT_TARIFF_STANDARD_48H_PT: 'CTT 48h',
  PRODUCT_TARIFF_STANDARD_14H_PT: 'CTT 14h',
  PRODUCT_TARIFF_STANDARD_24H_PT: 'CTT 24h',
  PRODUCT_TARIFF_STANDARD_E24H_PT: 'CTT e24h / Easy Return',
  PRODUCT_TARIFF_STANDARD_E48H_PT: 'CTT e48h (Em 2 Dias)',
  PRODUCT_TARIFF_STANDARD_PTIEXPRESS: 'CTT 24h (Ilhas PT)',
  PRODUCT_TARIFF_STANDARD_PTIEXPRESS_RAA: 'CTT 24h (Ilhas PT) - Açores',
  PRODUCT_TARIFF_STANDARD_PTIEXPRESS_LPMA: 'CTT 24h (Ilhas PT) - Madeira',
  PRODUCT_TARIFF_STANDARD_PTIECONOMY: 'CTT Marítimo (Ilhas PT)',
  PRODUCT_TARIFF_STANDARD_BALECONOMY: 'CTT Marítimo (Baleares)',
  PRODUCT_TARIFF_STANDARD_CANECONOMY: 'CTT Marítimo (Canárias)',
  PRODUCT_TARIFF_STANDARD_OTHERDESTINATIONS_PT: 'Outros Destinos',
  PRODUCT_TARIFF_STANDARD_CCAR_PT: 'Carga',
  PRODUCT_OtrosDestinos: 'Outros Destinos',
  PRODUCT_CanariasAereo: 'Canarias (Aéreo)',
  PRODUCT_Interilhas_PT: 'Interilhas PT',
  PRODUCT_InterilhasPT: 'Interilhas PT',
  PRODUCT_BalearesAereo: 'Baleares (Aéreo)',
  PRODUCT_BalearesMaritimo: 'Baleares (Marítimo)',
  PRODUCT_IlhasPTE: 'Ilhas PT (Aéreo)',
  PRODUCT_IlhasPTM: 'Ilhas PT (Marítimo)',
  PRODUCT_JSON_CANEXPRESS: 'CTT Canarias Documentación',
  PRODUCT_TARIFF_CANARY_ECOMMERCE: 'CTT Canarias Aéreo',
  PRODUCT_TARIFF_STANDARD_CCA24: 'CTT Canarias Aéreo 24h',
  PRODUCT_TARIFF_STANDARD_CCA48: 'CTT Canarias Aéreo 48h',
  PRODUCT_TARIFF_CANARY_MARITIME: 'CTT Canarias Marítimo',
  PRODUCT_JSON_BALEXPRESS: 'CTT Baleares Express',
  PRODUCT_JSON_BALECONOMY: 'CTT Baleares Economy',
  PRODUCT_JSON_INTEXP: 'CTT Internacional Express',
  PRODUCT_JSON_INTSTD: 'CTT Internacional Economy',
  PRODUCT_TARIFF_STANDARD_CIEL: 'CTT Internacional Europa Light', 


  //PDF
  PDF_GENERATING: 'Generando el contrato',
  WEIGHT: 'Peso',
  ADD_KILO: 'Kg adic',
  ZONE_Prov: 'Provincial',
  ZONE_Reg: 'Regional',
  ZONE_Peninsular: 'Peninsular',
  ZONE_PeninsularPlus: 'Peninsular+',
  ZONE_ZONE1: 'Zona 1',
  ZONE_ZONE2: 'Zona 2',
  ZONE_ZONE3: 'Zona 3',
  ZONE_ZONE4: 'Zona 4',
  ZONE_ZONE5: 'Zona 5',
  ZONE_ZONE6: 'Zona 6',
  ZONE_ZONE7: 'Zona 7',
  ZONE_ZONE8: 'Zona 8',
  ZONE_ZONE9: 'Zona 9',
  ZONE_FRANCIA: 'Francia',
  ZONE_FR: 'Francia',
  ZONE_BALMAY: 'Mallorca',
  ZONE_BALMEN: 'Resto Islas',
  ZONE_DE: 'Alemania',
  ZONE_UK: 'Reino Unido *',
  ZONE_IT: 'Italia',
  ZONE_BE: 'Bélgica',
  ZONE_NL: 'Holanda',
  ZONE_LU: 'Luxemburgo',
  ZONE_GB: 'Reino Unido',
  ZONE_Ceuta: 'Ceuta',
  ZONE_Melilla: 'Melilla',
  ZONE_ANDORRA: 'Andorra',
  ZONE_GIBRALTAR: 'Gibraltar',
  ZONE_PTISLANDS: 'Islas Portugal',
  ZONE_PTIAEREO: 'Islas Portugal Aéreo',
  ZONE_PTIMARITIMO: 'Islas Portugal Marítimo',
  ZONE_CANMAY: 'Lpa - Tnf',
  ZONE_Portugal: 'Portugal',
  ZONE_TNFLPA: 'Tnf & Lpa',
  ZONE_IMENORES: 'I. Menores',
  ZONE_INTERI: 'Interislas',
  ZONE_MALLORCA: 'Mallorca',
  ZONE_Madrid: 'Madrid',
  ZONE_ZONEA: 'Zona A',
  ZONE_ZONEB: 'Zona B',
  ZONE_ZONEC: 'Zona C',
  ZONE_ZONED: 'Zona D',
  ZONE_ZONEE: 'Zona E',
  ZONE_ZONEF: 'Zona F',
  ZONE_ZONEG: 'Zona G',
  ZONE_ZONEH: 'Zona H',
  ZONE_ZONEI: 'Zona I',
  ZONE_ZONES: 'Zona S',
  ZONE_ZONET: 'Zona T',
  ZONE_ZONEU: 'Zona U',
  ZONE_ZONEV: 'Zona V',
  ZONE_ZONEW: 'Zona W',
  ZONE_ZONEX: 'Zona X',
  ZONE_ZONEY: 'Zona Y',
  ZONE_Gibraltar: 'Gibraltar',
  ZONE_Andorra: 'Andorra',
  ZONE_TnfLpa: 'Tnf & Lpa',
  ZONE_IMenores: 'Outras Ilhas',
  ZONE_MesmaIlha: 'Mesma Ilha',
  ZONE_MesmoArquipelago: 'Mesmo Arquipélago',
  ZONE_EntreArquipelagos: 'Entre Arquipélagos',
  ZONE_Maiorca: 'Maiorca',
  ZONE_OutrasIlhas: 'Outras Ilhas',
  ZONE_Madeira: 'Madeira',
  ZONE_Açores: 'Açores',
  ZONE_PORTUGAL: 'Portugal',
  ZONE_SPAIN: 'España',
  ZONE_MADEIRA: 'Madeira',
  ZONE_OTHER_ISLANDS: 'I. Menores',
  ZONE_INTERILHAS: 'Interilhas',
  ZONE_ARQUIPELAGOS: 'Arquipélagos',
  ZONE_AZORES_PT: 'Açores',
  ZONE_MAJORCA_PT: 'Maiorca',
  ZONE_OTHER_ISLANDS_PT: 'Outras Ilhas',
  ZONE_PORTUGAL_CONTINENTE: 'Portugal Continental',
  // Alias para compatibilidad con backend
  ZONE_ACORES: 'Açores',
  ZONE_CEUTA: 'Ceuta',
  ZONE_MELILLA: 'Melilla',
  ZONE_SPAIN_PT: 'Espanha',
  
  //NOTES
    NOTE_INSULAR: "<b>Nota:</b> Qualquer fluxo não constante nesta proposta comercial, pode ser disponibilizado ao cliente, sendo faturado de acordo com a tabela oficial de preços em vigor." ,
    NOTE_PENINSULAR: "<b>Nota:</b> Qualquer fluxo não constante na proposta comercial, pode ser disponibilizado ao cliente, sendo faturado de acordo com a tabela oficial de preços em vigor." ,
  
  // EXCEL EXPORT
  EXPORT_TO_EXCEL: 'Exportar a Excel',
  EXPORT_EXCEL_SUCCESS: 'Oferta exportada correctamente a Excel',
  EXPORT_EXCEL_ERROR: 'Error al exportar la oferta a Excel',
  
  // EXCEL EXPORT - LABELS (ES/PT)
  EXCEL_TITLE_ES: 'OFERTA COMERCIAL CTT EXPRESS',
  EXCEL_TITLE_PT: 'OFERTA COMERCIAL CTT EXPRESS',
  EXCEL_INFO_GENERAL_ES: 'INFORMACIÓN GENERAL',
  EXCEL_INFO_GENERAL_PT: 'INFORMAÇÃO GERAL',
  EXCEL_PRODUCTS_PRICES_ES: 'PRODUCTOS Y PRECIOS',
  EXCEL_PRODUCTS_PRICES_PT: 'PRODUTOS E PREÇOS',
  EXCEL_PRODUCT_LABEL_ES: 'Producto:',
  EXCEL_PRODUCT_LABEL_PT: 'Produto:',
  EXCEL_OFFER_LABEL_ES: 'Oferta:',
  EXCEL_OFFER_LABEL_PT: 'Oferta:',
  EXCEL_WEIGHT_ES: 'Peso (kg)',
  EXCEL_WEIGHT_PT: 'Peso (kg)',
  EXCEL_ADDITIONAL_KG_ES: 'Kg Adicional',
  EXCEL_ADDITIONAL_KG_PT: 'Kg Adicional',
  EXCEL_NO_PRODUCTS_ES: 'No hay productos seleccionados',
  EXCEL_NO_PRODUCTS_PT: 'Não há produtos selecionados',
  EXCEL_PAYMENT_METHODS_ES: 'MÉTODOS DE PAGO',
  EXCEL_PAYMENT_METHODS_PT: 'MÉTODOS DE PAGAMENTO',
  EXCEL_SELECTED_METHOD_ES: 'Método Seleccionado:',
  EXCEL_SELECTED_METHOD_PT: 'Método Selecionado:',
  EXCEL_PAYMENT_DAY_ES: 'Día de Pago:',
  EXCEL_PAYMENT_DAY_PT: 'Dia de Pagamento:',
  EXCEL_ADDITIONAL_SERVICES_ES: 'SERVICIOS ADICIONALES',
  EXCEL_ADDITIONAL_SERVICES_PT: 'SERVIÇOS ADICIONAIS',
  EXCEL_SERVICE_POINTS_ES: 'PUNTOS DE SERVICIO',
  EXCEL_SERVICE_POINTS_PT: 'PONTOS DE SERVIÇO',
  EXCEL_ADDRESS_ES: 'Dirección',
  EXCEL_ADDRESS_PT: 'Endereço',
  EXCEL_CITY_ES: 'Ciudad',
  EXCEL_CITY_PT: 'Cidade',
  EXCEL_COMMITTED_SHIPMENTS_ES: 'Envíos Comprometidos',
  EXCEL_COMMITTED_SHIPMENTS_PT: 'Envios Comprometidos',
  EXCEL_FAVORITE_ES: 'Favorito',
  EXCEL_FAVORITE_PT: 'Favorito',
  EXCEL_BANK_DETAILS_ES: 'DATOS BANCARIOS',
  EXCEL_BANK_DETAILS_PT: 'DADOS BANCÁRIOS',
  EXCEL_IBAN_ES: 'IBAN:',
  EXCEL_IBAN_PT: 'IBAN:',
  EXCEL_IBAN2_ES: 'IBAN2 (Devoluciones):',
  EXCEL_IBAN2_PT: 'IBAN2 (Devoluções):',
  EXCEL_BANK_GUARANTEE_ES: 'GARANTÍA BANCARIA',
  EXCEL_BANK_GUARANTEE_PT: 'GARANTIA BANCÁRIA',
  EXCEL_AMOUNT_ES: 'Importe:',
  EXCEL_AMOUNT_PT: 'Montante:',
  EXCEL_TYPE_ES: 'Tipo:',
  EXCEL_TYPE_PT: 'Tipo:',
  EXCEL_DURATION_ES: 'Duración:',
  EXCEL_DURATION_PT: 'Duração:',
  EXCEL_ID_OFFER_ES: 'ID Oferta:',
  EXCEL_ID_OFFER_PT: 'ID Oferta:',
  EXCEL_CLIENT_ES: 'Cliente:',
  EXCEL_CLIENT_PT: 'Cliente:',
  EXCEL_CIF_ES: 'CIF:',
  EXCEL_CIF_PT: 'NIF:',
  EXCEL_CITY_GENERAL_ES: 'Ciudad:',
  EXCEL_CITY_GENERAL_PT: 'Cidade:',
  EXCEL_ADDRESS_GENERAL_ES: 'Dirección:',
  EXCEL_ADDRESS_GENERAL_PT: 'Endereço:',
  EXCEL_LEGAL_CITY_ES: 'Ciudad Jurídica:',
  EXCEL_LEGAL_CITY_PT: 'Cidade Jurídica:',
  EXCEL_COMMITTED_DELIVERIES_ES: 'Envíos Comprometidos:',
  EXCEL_COMMITTED_DELIVERIES_PT: 'Envios Comprometidos:',
  EXCEL_B2B_DIST_ES: 'Distribución B2B:',
  EXCEL_B2B_DIST_PT: 'Distribuição B2B:',
  EXCEL_B2C_DIST_ES: 'Distribución B2C:',
  EXCEL_B2C_DIST_PT: 'Distribuição B2C:',
  EXCEL_OFFER_TYPE_ES: 'Tipo de Oferta:',
  EXCEL_OFFER_TYPE_PT: 'Tipo de Oferta:',
  EXCEL_STATUS_ES: 'Estado:',
  EXCEL_STATUS_PT: 'Estado:',
  EXCEL_VALIDATION_STATUS_ES: 'Estado de Validación:',
  EXCEL_VALIDATION_STATUS_PT: 'Estado de Validação:',
  EXCEL_NOT_INCLUDED_ES: 'No incluido',
  EXCEL_NOT_INCLUDED_PT: 'Não incluído',
  EXCEL_YES_ES: 'Sí',
  EXCEL_YES_PT: 'Sim',
  EXCEL_NO_ES: 'No',
  EXCEL_NO_PT: 'Não',
  TX_CIES_EXP_GB: 'Gestión Aduanera de Exportación (Reino Unido)',
  TX_CIES_REVERSAL: 'Tarifas de Reversión Aduanera (en caso de devolución del envío)',
  TX_CIES_EXC_DIM: 'Suplemento de exceso de medidas (120x600x60 hasta 200x120x80)',
  TX_CIES_DEMANDA: 'Tasa de Alta demanda para períodos de alta actividad',
  TX_CIES_AREAS_REMOTAS: 'Áreas remotas',
  TX_CIES_IMP_ADUANERO: 'Servicio de importación',
  TX_CIEL_SEG_VOLUNTARIO: 'Incremento de indemnización legal por pérdida o robo: Límite hasta 2.000 €/envío (ley 15/09 CTTM. Art.63). (Excluidas roturas, desperfectos, averías que se abonarán de acuerdo a lo recogido en CMR)',
  TX_CIEL_DELIVERY_NOTE: 'Prueba de entrega física',
  TX_CIEL_ENTREGA_ADICIONAL: 'Suplemento entrega adicional (cambio o corrección de dirección y ausencia del destinatario)',
  TX_CIEL_EXC_PESO_25: 'Suplemento para aquellos bultos del envío que superen los 25 kg de peso real o los 50 kg de peso volumétrico',
  TX_CIEL_EXC_PESO_50: 'Suplemento para aquellos bultos del envío que superen los 50 kg de peso real o los 70 kg de peso volumétrico',
  TX_CIEL_EXC_DIM_100: 'Suplemento aplicable cuando cualquiera de las medidas supere la dimensión de >100 cm y <=120 cm',
  TX_CIEL_EXC_DIM_120: 'Suplemento aplicable cuando cualquiera de las medidas supere la dimensión de <120 cm y <=175 cm',
  TX_CIEL_EXC_DIM_175: 'Suplemento aplicable cuando cualquiera de las medidas supere la dimensión de >175 cm',
  TX_CIEL_EXC_DIM_SUM: 'Suplemento exceso de suma de medidas por bulto (alto+ancho+largo) superior a 250 cm',
  TX_CIEL_SPECIAL_HANDLING: 'Manipulación Especial',
  TX_CIEL_EXC_ITEM: 'Suplemento por bulto o palets no apilables',
  TX_CIEL_HIELO_SECO: 'Hielo seco < 20 Kg',
  TX_CIEL_EXC_HIELO_SECO: 'Hielo seco > 20 Kg',
  TX_CIEL_AREAS_REMOTAS: 'Áreas remotas',
  TX_CIEL_SERVICIO_ISLAS: 'Servicio Islas (suplemento para envíos con destino islas no específicamente incluidas como zona)',
  TX_CIEL_EXP_FUERA_EU: 'Trámite exportación (envíos con valor >150 € con destino fuera de la Unión Europea)',
  TX_CIEL_EXP_GB: 'Tasa administrativa de aduanas - Reino Unido',
  TX_CIEL_DUTY: 'Aranceles',
  TX_CIEL_PEAK: 'Tasa de Alta demanda para periodos de alta actividad',

}
